// extracted by mini-css-extract-plugin
export default {"spaceBetween":"CardProductsHero_spaceBetween__AjFpz","flexDiv":"CardProductsHero_flexDiv__d8AMT","customSpacer":"CardProductsHero_customSpacer__uf-nS"};